import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
export const MakeSteps = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: "2. Log in to your Make account and create a scenario with Anchor"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: "3. Paste the API key when setting up the connection"
            })
        ]
    });
